export const API_URL = 'https://admin.owayride.com';
export const MAP_URL = 'https://maps.googleapis.com';